export default __webpack_public_path__ + "static/media/burntodeath4.496d8ae2.png";